// @ts-nocheck
import CSSLoader from "@components/CSSLoader";
import useAppContext from "@hooks/useAppContext";
import useSliderScrollBlock from "@hooks/useSliderScrollBlock";
import React, { createContext, useCallback, useMemo, useState } from "react";
import Slider, { Settings as SliderSettings } from "react-slick";

const MAX_CARDS = 9;

export const SliderContext = createContext({
  preventCarouselClick: (
    e: MouseEvent<HTMLAnchorElement, MouseEvent>,
    callback?: () => void
  ) => {},
  preventCarouselSwipe: (
    e: React.TouchEvent<HTMLDivElement> | MouseEvent<HTMLDivElement, MouseEvent>
  ) => {},
});

interface ISliderCarousel {
  components?: JSX.Element | JSX.Element[];
  settings: SliderSettings;
  noCardsLimit?: boolean;
}

const SliderCarousel = ({
  components,
  settings,
  noCardsLimit,
}: ISliderCarousel): JSX.Element => {
  const { isMobile } = useAppContext();
  const { containerRef } = useSliderScrollBlock();
  const [position, setPosition] = useState({
    clientXonMouseDown: null,
    clientYonMouseDown: null,
  });

  const sliderComponents = useMemo(() => {
    return components?.slice();
  }, [components]);

  const handleOnMouseDown = useCallback(
    (e) => {
      setPosition({
        clientXonMouseDown: e.clientX,
        clientYonMouseDown: e.clientY,
      });
      e.preventDefault();
    },
    [setPosition]
  );

  const isClick = useCallback(
    (e) => {
      return !(
        !isMobile &&
        (position.clientXonMouseDown !== e.clientX ||
          position.clientYonMouseDown !== e.clientY)
      );
    },
    [position, isMobile]
  );

  const preventCarouselClick = useCallback(
    (e, callback) => {
      if (isClick && !isClick(e)) {
        e.cancelBuble = true;
        e.stopPropagation();
        e.preventDefault();
      } else {
        if (callback) {
          callback();
        }
      }
    },
    [isClick]
  );
  const preventCarouselSwipe = (
    e: React.TouchEvent<HTMLDivElement> | MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    e.stopPropagation();
  };

  return (
    <>
      <SliderContext.Provider
        value={{ preventCarouselClick, preventCarouselSwipe }}
      >
        <CSSLoader slider />

        <div ref={containerRef} onMouseDown={handleOnMouseDown}>
          <Slider {...settings}>
            {noCardsLimit
              ? sliderComponents
              : sliderComponents?.slice(0, MAX_CARDS)}
          </Slider>
        </div>
      </SliderContext.Provider>
    </>
  );
};

export default SliderCarousel;
